var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImport2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "ImportBtnsHeaderIcon",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.12518 10.5192L7.64515 12.0392C7.84048 12.2345 8.15715 12.2345 8.35248 12.0392L9.87248 10.5192C10.0678 10.3238 10.0678 10.0072 9.87248 9.81185C9.76882 9.70818 9.63115 9.65951 9.49555 9.66591V9.66431H8.49915V7.19385H7.49915V9.66431H6.42392V9.66838C6.31479 9.68038 6.20886 9.72818 6.12518 9.81185C6.02785 9.90985 5.97852 10.0378 5.97852 10.1658C5.97852 10.2938 6.02785 10.4218 6.12518 10.5192Z",
    fill: "url(#paint0_linear_1907_1316)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8996 10.4868V11.6875C13.8996 13.2861 12.5983 14.5868 10.9996 14.5868H4.99961C3.40028 14.5868 2.09961 13.2861 2.09961 11.6875V10.4868C2.09961 10.2108 2.32361 9.98682 2.59961 9.98682C2.87561 9.98682 3.09961 10.2108 3.09961 10.4868V11.6875C3.09961 12.7348 3.95161 13.5868 4.99961 13.5868H10.9996C12.0476 13.5868 12.8996 12.7348 12.8996 11.6875V10.4868C12.8996 10.2108 13.1236 9.98682 13.3996 9.98682C13.6756 9.98682 13.8996 10.2108 13.8996 10.4868Z",
    fill: "url(#paint1_linear_1907_1316)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.26562 7.1949H7.49962H11.733C12.8356 7.1949 13.733 6.29756 13.733 5.19489V3.74756C13.733 2.64489 12.8356 1.74756 11.733 1.74756H4.26562C3.16296 1.74756 2.26562 2.64489 2.26562 3.74756V5.19489C2.26562 6.29756 3.16296 7.1949 4.26562 7.1949Z",
    fill: "url(#paint2_linear_1907_1316)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1907_1316",
    x1: 5.97852,
    y1: 7.19385,
    x2: 5.97852,
    y2: 12.1857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1907_1316",
    x1: 2.09961,
    y1: 9.98682,
    x2: 2.09961,
    y2: 14.5868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1907_1316",
    x1: 2.26562,
    y1: 1.74756,
    x2: 2.26562,
    y2: 7.1949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7D9FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport2);
export default __webpack_public_path__ + "static/media/import2.3f5ed646.svg";
export { ForwardRef as ReactComponent };